
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { URLS } from '../../../_config/api.config';
import { ApiService } from '../../../services/api-data.service';
import { CommonService } from '../../../services/common.service';

@Component({
	selector: 'app-all-orgs-modal',
	templateUrl: './all-orgs-modal.component.html',
	styleUrls: ['./all-orgs-modal.component.scss']
})
export class AllOrgsModalComponent implements OnInit {

	private subscription: Subscription = new Subscription();
	public isLoading = false;
	category = [];
	tiers = ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4']
	organizations = [];
	totalCount: number = 0; // Total number of items from API
	totalPages: number = 0; // Total number of pages
	currentPage: number = 1; // Current page number
	itemsPerPage: number = 11; // Number of items per page
	selectedOption = 'All';
	selectedOption2='All';
	categoryselectedOption='All';
	isOpen = false;
	isOpen2 = false;
	// searchTerm: string = '';
	searchControl = new FormControl('');
	searchSub: Subscription | null = null;
	listenerInitialized = false;
	/** Serializes list requests; cancels in-flight HTTP when a newer request starts. */
	private readonly loadCharityList$ = new Subject<any>();
	@Input() calledFrom: string = '';
	@Output() action = new EventEmitter<any>();
	@Output() lockScreen = new EventEmitter<boolean>();
	constructor(
		private router: Router,
		private commonService: CommonService,
		private dataService: ApiService,
		private cdr: ChangeDetectorRef,
		private toastr: ToastrService,
		@Inject(DOCUMENT) private document: any
	) { }

	ngOnInit(): void {
		this.subscription.add(
			this.loadCharityList$
				.pipe(
					switchMap((dataParams) => {
						const params = {
							page: this.currentPage,
							size: this.itemsPerPage,
							...(dataParams || {})
						};

						if (this.searchControl.value && !params['search'] && this.searchControl.value.trim() !== '') {
							params['search'] = this.searchControl.value;
						}

						this.isLoading = true;
						return this.dataService.get(URLS.getcharityList, params).pipe(
							tap({
								next: (data) => {
									if (data['code'] == 200) {
										if (data['data']) {
											this.organizations = data['data']['result'];
											const orgs = this.organizations.find((items) => { return items.tier !== 1; });
											{
												if (orgs) {
													this.lockScreen.emit(false);
												} else {
													this.lockScreen.emit(true);
												}
											}
											this.totalCount = data['data']['totalCount'];
											this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
										}
									} else {
										this.toastr.error(data['message'], "Error");
									}
								},
								error: (error) => {
									this.toastr.error(error['message'], "Error");
								}
							}),
							finalize(() => {
								this.isLoading = false;
							})
						);
					})
				)
				.subscribe()
		);

		this.getCategory();
		this.getCharityList();
		this.initializeSearchListener();
	}

	getCategory() {
		this.subscription.add(
			this.dataService.get(URLS.getPromotionCategory).subscribe(data => {
				if (data['code'] == 200) {
					if (data['data']) {
						this.category = data['data'];
					}
				} else {
					this.toastr.error(data['message'], "Error");
				}
			}, error => {
				this.toastr.error(error['message'], "Error");
			})
		)
	}

	getCharityList(dataParams?) {
		// Push into the serialized loader stream to avoid stale UI on rapid searches.
		this.loadCharityList$.next(dataParams);
	}

	initializeSearchListener() {
		if (!this.listenerInitialized) {
			this.listenerInitialized = true;
			this.searchSub = this.searchControl.valueChanges
				.pipe(
					debounceTime(700),
					distinctUntilChanged(),
					filter((term: string | null) => !term || term.length === 0 || term.length > 2)
				)
				.subscribe(searchTerm => {
					if (searchTerm.length === 0) {
						this.currentPage=1
						let params = { }
						if (this.categoryselectedOption != 'All') {
							params['category'] = this.categoryselectedOption['_id'];
						}
						if (this.selectedOption2) {
							if (this.selectedOption2 == 'Tier 1')
								params['tier'] = 1;
							else if (this.selectedOption2 == 'Tier 2')
								params['tier'] = 2;
							else if (this.selectedOption2 == 'Tier 3')
								params['tier'] = 3;
							else if (this.selectedOption2 == 'Tier 4')
								params['tier'] = 4;
						}
						this.currentPage=1
						this.getCharityList(params);
					} else {
						let params = { search: searchTerm }
						if (this.categoryselectedOption != 'All') {
							params['category'] = this.categoryselectedOption['_id'];
						}
						if (this.selectedOption2) {
							if (this.selectedOption2 == 'Tier 1')
								params['tier'] = 1;
							else if (this.selectedOption2 == 'Tier 2')
								params['tier'] = 2;
							else if (this.selectedOption2 == 'Tier 3')
								params['tier'] = 3;
							else if (this.selectedOption2 == 'Tier 4')
								params['tier'] = 4;
						}
						this.currentPage=1
						this.getCharityList(params);
					}
				});
		}
	}

	ngOnDestroy() {
		this.searchSub?.unsubscribe();
		this.loadCharityList$.complete();
	}

	onPageChange(page: number) {
		this.currentPage = page;
		if (this.totalPages > 1) {
			this.selectOption2(null, this.selectedOption2);
			// this.getCharityList();
		}
	}

	toggleDropdown(event: MouseEvent) {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	toggleDropdown2(event: MouseEvent) {
		event.stopPropagation();
		this.isOpen2 = !this.isOpen2;
	}

	closeDropdown2() {
		setTimeout(() => {
			this.isOpen2 = false;
			this.cdr.detectChanges();
		});
	}

	selectOption2(event, option) {
		if(event)
		event.stopPropagation();
		this.isOpen2 = false;
		if (option === 'all') {
			this.selectedOption2 = 'All';
			if (this.categoryselectedOption != 'All' ) {
				let params = {}
				params['category'] = this.categoryselectedOption['_id'];
				this.getCharityList(params);
			}
			else if(this.searchControl.value){
				this.getCharityList({search: this.searchControl.value});
			}
			else
			this.getCharityList();
		} else {
			this.selectedOption2 = option
			let params = {}
			if (option) {
				if(option=='Tier 1')
				params['tier'] = 1;
			    else if(option=='Tier 2')
				params['tier'] = 2;
			    else if(option=='Tier 3')
				params['tier'] = 3;
			    else if(option=='Tier 4')
				params['tier'] = 4;
			}

			if (this.categoryselectedOption != 'All' ) {
				params['category'] = this.categoryselectedOption['_id'];
			}

			if(this.searchControl.value)
			{
				params['search'] =this.searchControl.value;
			}
			this.getCharityList(params);
		}
	}

	closeDropdown() {
		setTimeout(() => {
			this.isOpen = false;
			this.cdr.detectChanges();
		});
	}

	selectOption(event, option) {
		event.stopPropagation();
		this.isOpen = false;
		if (option === 'all') {
			this.selectedOption = 'All';
			this.categoryselectedOption = 'All';

			if (this.selectedOption2) {
				let params = {}
				if(this.selectedOption2=='Tier 1')
				params['tier'] = 1;
			    else if(this.selectedOption2=='Tier 2')
				params['tier'] = 2;
			    else if(this.selectedOption2=='Tier 3')
				params['tier'] = 3;
			    else if(this.selectedOption2=='Tier 4')
				params['tier'] = 4;
			this.getCharityList(params);
			}
			else if(this.searchControl.value){
				this.getCharityList({search: this.searchControl.value});
			}
			else
			this.getCharityList();
		} else {
			this.selectedOption = option.name;
			this.categoryselectedOption=option;
			let params = {}
			if (option._id) {
				params['category'] = option._id;
			}
			if (this.selectedOption2) {
				if(this.selectedOption2=='Tier 1')
				params['tier'] = 1;
			    else if(this.selectedOption2=='Tier 2')
				params['tier'] = 2;
			    else if(this.selectedOption2=='Tier 3')
				params['tier'] = 3;
			    else if(this.selectedOption2=='Tier 4')
				params['tier'] = 4;
			}

			if(this.searchControl.value)
			{
				params['search'] =this.searchControl.value;
			}

			this.getCharityList(params);
		}
	}

	navigate(action?, data?) {
		// this.router.navigateByUrl('newOrgDashboard');
		if (this.calledFrom !== 'insightsPage') {
			if (action == 'allOrg') {
				this.action.emit('allOrgs');
			} else if (action == 'org') {
				this.commonService.localStorageSet('orgId', data.orgId);
				this.commonService.localStorageSet('orgName', data.orgName);
				this.action.emit(data.orgName);
			}
		} else {
			if (action == 'allOrg') {
				this.action.emit('allOrgs');
			} else if (action == 'org') {
				this.commonService.localStorageSet('orgId', data.orgId);
				this.commonService.localStorageSet('orgName', data.orgName);
				this.action.emit(data);
			}
		}
	}

	resetSearchInput(){
		this.searchControl.setValue('');
		this.selectedOption = 'All';
		this.selectedOption2 = 'All';
		this.categoryselectedOption = 'All';
		this.currentPage=1;
		this.getCharityList();
	}

}
